const findFirstTextElement = (element) => {
    const hasDirectText = Array.from(element.childNodes).some(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim(),
    );

    if (hasDirectText) {
        return element;
    }

    // Otherwise, recursively check children
    for (const child of element.children) {
        const result = findFirstTextElement(child);
        if (result) {
            return result;
        }
    }

    return null;
};

export const assembleArticleCopyContent = ({
    articleId,
    project,
    stage,
    articleType,
    content,
    area,
}) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    const firstTextElement = findFirstTextElement(doc.body) ?? doc.body;

    const span = doc.createElement("span");
    span.setAttribute("data-articleid", articleId);
    span.setAttribute("data-project", project);
    span.setAttribute("data-stage", stage);
    span.setAttribute("data-articletype", articleType);
    if (area) {
        span.setAttribute("data-area", area);
    }
    span.setAttribute("type", "article");
    span.setAttribute("target", "_blank");
    span.setAttribute("class", "captis-link");

    span.innerHTML = firstTextElement.innerHTML;
    firstTextElement.innerHTML = "";
    firstTextElement.appendChild(span);

    return doc.body.innerHTML;
};

export const assembleMixedCopyContent = ({ references, project, content }) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    const wrapElement = (element, ref) => {
        const span = doc.createElement("span");
        span.setAttribute("data-project", project);
        span.setAttribute("target", "_blank");
        span.setAttribute("class", "captis-link");

        if (ref.type === "article") {
            span.setAttribute("data-articleid", ref.articleId);
            span.setAttribute("data-stage", ref.stage);
            span.setAttribute("data-articletype", ref.articleType);
            if (ref.area) {
                span.setAttribute("data-area", ref.area);
            }
            span.setAttribute("type", "article");
        } else {
            span.setAttribute("data-area", ref.area);
            span.setAttribute("data-documentid", ref.documentId);
            span.setAttribute("type", "source-document");
        }

        span.innerHTML = element.innerHTML;
        element.innerHTML = "";
        element.appendChild(span);
    };

    const mappedElements = doc.querySelectorAll("[data-ref-mapping]");

    if (mappedElements.length > 0) {
        mappedElements.forEach((element, i) => {
            if (references[i]) {
                wrapElement(element, references[i]);
            }
        });
    } else {
        const firstRef = references.find(Boolean);
        if (firstRef) {
            const firstTextElement = findFirstTextElement(doc.body) ?? doc.body;
            wrapElement(firstTextElement, firstRef);
        }
    }

    return doc.body.innerHTML;
};

export const assembleCopyContent = ({ references, project, content }) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    const wrapElementContent = (element, documentId, area) => {
        const span = doc.createElement("span");

        span.setAttribute("data-area", area);
        span.setAttribute("data-documentid", documentId);
        span.setAttribute("data-project", project);
        span.setAttribute("type", "source-document");
        span.setAttribute("target", "_blank");
        span.setAttribute("class", "captis-link");

        span.innerHTML = element.innerHTML;
        element.innerHTML = "";
        element.appendChild(span);
    };

    const mappedElements =
        references?.length > 0 ? doc.querySelectorAll("[data-ref-mapping]") : null;
    const ref = references?.[0];

    if (mappedElements?.length > 0) {
        mappedElements.forEach(
            (element, i) =>
                references[i] &&
                wrapElementContent(element, references[i].documentId, references[i].area),
        );
    } else {
        const firstTextElement = findFirstTextElement(doc.body) ?? doc.body;
        wrapElementContent(firstTextElement, ref?.documentId, ref?.area);
    }

    return doc.body.innerHTML;
};
